

















import {Component, Vue} from 'vue-property-decorator';


@Component
export default class MainView extends Vue {
  private current = ['print'];

}
